import { Link } from "react-router-dom";
import { VENDOR_GROUPS, getVisibility, listVendors } from "@hub";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function Vendors() {
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  if (visibility.vendors === false) {
    return (
      <article>
        <h1>Vendors</h1>
        <p className="lead">This directory is hidden for now.</p>
      </article>
    );
  }
  const vendors = listVendors();
  const proCount = vendors.filter((item) => item.audience === "pro").length;
  const clientCount = vendors.filter((item) => item.audience === "client").length;

  return (
    <article>
      <h1>Vendor hub</h1>
      <p className="lead">
        Two directories: real-estate professionals who support the listing, and client-support trades
        for the week of moving. Not a marketplace and not a bid wall. Region default: San Diego County.
      </p>
      <div className="card-grid">
        <section className="card">
          <h2>Real estate pros</h2>
          <p>
            Photographers, staging, renovation, cleaning, landscape, drone, virtual tours, signs,
            lockbox, escrow, and title — plus office tools and associations.
          </p>
          <p className="muted">{proCount} placeholders on this origin.</p>
          <p>
            <Link className="btn" to={withVisitor("/vendors/pro", visitor)}>
              Open pro directory
            </Link>
          </p>
        </section>
        <section className="card">
          <h2>Client support</h2>
          <p>
            Movers, cleaners, handymen, painters, landscapers, inspectors, pest control, plumbers,
            and electricians — plus education primers.
          </p>
          <p className="muted">{clientCount} placeholders on this origin.</p>
          <p>
            <Link className="btn" to={withVisitor("/vendors/client", visitor)}>
              Open client directory
            </Link>
          </p>
        </section>
      </div>
      <section className="hub-section">
        <h2>Categories at a glance</h2>
        <div className="card-grid">
          <section className="card">
            <h3>Pro groups</h3>
            <ul className="plain-list">
              {VENDOR_GROUPS.pro.map((group) => (
                <li key={group.id}>
                  <Link to={withVisitor(`/vendors/pro?group=${group.id}`, visitor)}>{group.label}</Link>
                </li>
              ))}
            </ul>
          </section>
          <section className="card">
            <h3>Client groups</h3>
            <ul className="plain-list">
              {VENDOR_GROUPS.client.map((group) => (
                <li key={group.id}>
                  <Link to={withVisitor(`/vendors/client?group=${group.id}`, visitor)}>{group.label}</Link>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </section>
      <p className="muted">Admin vendor management lives on REChecklist Controls. Search is on each directory page.</p>
    </article>
  );
}
